import { get } from '@core/api/baseApi';
import { GetAssignedReferralsAndGroupsResponse } from '@core/types';

const getAssignedReferralsAndGroups = async (
  studyInstanceUid: string,
): Promise<GetAssignedReferralsAndGroupsResponse> =>
  await get(`/Studies/${studyInstanceUid}/authorized-referral`);

export default getAssignedReferralsAndGroups;
